
import React, { useState, useEffect } from 'react';
import './App.css';


const initialValue = {
   startdate: '',
   enddate: '',
   amount: ''
};

export default function GratuityCalculator() {
    const [timestr, setTimestr] = useState('');
    const [gratuity, setGratuity] = useState('0');
    const [values, setValues] = useState(initialValue);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (values.amount && timestr) {
            totalAmount();
        }
    }, [values.amount, timestr]);

    const validateDates = (startDate, endDate) => {
        if (!startDate || !endDate) return null;
        
        const start = new Date(startDate);
        const end = new Date(endDate);
        
        if (start > end) {
            setErrors(prev => ({
                ...prev,
                dates: "End date cannot be before start date"
            }));
            return false;
        }
        
        setErrors(prev => ({...prev, dates: null}));
        return true;
    };

    const calculateTimeDifference = (f_w_dt, l_w_d) => {
        if (!f_w_dt || !l_w_d) return false;
        
        if (!validateDates(f_w_dt, l_w_d)) {
            setTimestr('');
            return false;
        }
        
        let start_dt = new Date(new Date(f_w_dt).toISOString().substring(0, 10));
        let end_dt = new Date(new Date(l_w_d).toISOString().substring(0, 10));
        let start_year = start_dt.getFullYear();
        let end_year = end_dt.getFullYear();
        let feb = (start_year % 4 === 0 && start_year % 100 !== 0) || start_year % 400 === 0 ? 29 : 28;
        let feb_e = (end_year % 4 === 0 && end_year % 100 !== 0) || end_year % 400 === 0 ? 29 : 28;
        let day_of_m = [31, feb, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        let day_of_m_e = [31, feb_e, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        
        let year_diff = end_year - start_year;
        let month_diff = end_dt.getMonth() - start_dt.getMonth();
        
        if (month_diff < 0) {
            year_diff--;
            month_diff += 12;
        }
        
        let days_dif = end_dt.getDate() - start_dt.getDate() + 1;
        if (days_dif < 0) {
            if (month_diff > 0) {
                month_diff--;
            } else {
                year_diff--;
                month_diff = 11;
            }
            days_dif += day_of_m[start_dt.getMonth()];
        }
        
        if (days_dif === day_of_m_e[end_dt.getMonth()]) {
            month_diff++;
            days_dif = 0;
        }
        
        if (month_diff === 12) {
            year_diff++;
            month_diff = 0;
        }
        
        setTimestr({
            years: year_diff,
            months: month_diff,
            days: days_dif
        });
    };

    const OnValueChange = (e) => {
        const { name, value } = e.target;
        
        if (name === 'amount') {
            const numValue = Number(value);
            if (numValue < 0) {
                setErrors(prev => ({...prev, salary: "Salary cannot be negative"}));
                return;
            }
            setErrors(prev => ({...prev, salary: null}));
        }
        
        const newValues = {
            ...values,
            [name]: value
        };
        
        setValues(newValues);
        setGratuity('0');
        
        if (name === 'startdate' || name === 'enddate') {
            calculateTimeDifference(
                name === 'startdate' ? value : newValues.startdate,
                name === 'enddate' ? value : newValues.enddate
            );
        }
    };

    const handleReset = () => {
        setTimestr('');
        setGratuity('0');
        setValues(initialValue);
        setErrors({});
    };

    const validateCalculation = () => {
        const errors = {};
        
        if (!values.startdate) errors.startdate = "Start date is required";
        if (!values.enddate) errors.enddate = "End date is required";
        if (!values.amount) errors.amount = "Salary is required";
        
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const totalAmount = () => {
        if (!validateCalculation()) return;

        let salary = Number(values.amount);
        if (!timestr?.years || timestr.years < 1) {
            setErrors(prev => ({...prev, time: "Employment period must be at least 1 year"}));
            return;
        }
        
        let per_day = (salary / 30);
        let day_21_salary = (per_day * 21);
        
        let gratuity_total = 0;
        
        if (timestr.years >= 5) {
            const gratuity_for_five = day_21_salary * 5;
            const gratuity_after_five = salary * (timestr.years - 5);
            gratuity_total = gratuity_for_five + gratuity_after_five;
            
            if (timestr.months > 0) {
                gratuity_total += (salary / 12) * timestr.months;
            }
            if (timestr.days) {
                gratuity_total += (salary / 365) * timestr.days;
            }
        } else {
            gratuity_total = day_21_salary * timestr.years;
            if (timestr.months > 0) {
                gratuity_total += (day_21_salary / 12) * timestr.months;
            }
            if (timestr.days) {
                gratuity_total += (day_21_salary / 365) * timestr.days;
            }
        }
        
        if (gratuity_total > 0) {
            setGratuity(Math.round(gratuity_total));
        }
    };

    const calculate = (e) => {
        e.preventDefault();
        totalAmount();
    };

    return (
        <div className="gratuity-calculator-wrapper">
            <div className="gratuity-form">
                <div className="title">Gratuity Calculator</div>
                <div className="form__field">
                    <label>First working day</label>
                    <input
                        type="date"
                        name="startdate"
                        data-req-msg="Please select first working day"
                        value={values.startdate}
                        className={`txtbox ${errors.startdate ? 'error' : ''}`}
                        onChange={OnValueChange}
                    />
                    {errors.startdate && (
                        <span className="invalid-feedback d-block">{errors.startdate}</span>
                    )}
                </div>
                <div className="form__field">
                    <label>Last working day</label>
                    <input
                        type="date"
                        name="enddate"
                        data-req-msg="Please select last working day"
                        value={values.enddate}
                        className={`txtbox ${errors.enddate ? 'error' : ''}`}
                        onChange={OnValueChange}
                    />
                    {errors.dates && (
                        <span className="invalid-feedback d-block">{errors.dates}</span>
                    )}
                    {timestr && !errors.dates && (
                        <span className="time-str">
                            {timestr.years} years {timestr.months} months {timestr.days} days
                        </span>
                    )}
                </div>
                <div className="form__field">
                    <label>Basic salary</label>
                    <input
                        type="number"
                        name="amount"
                        data-req-msg="Please enter basic salary"
                        value={values.amount}
                        className={`txtbox ${errors.salary ? 'error' : ''}`}
                        onChange={OnValueChange}
                        min="0"
                    />
                    {errors.salary && (
                        <span className="invalid-feedback d-block">{errors.salary}</span>
                    )}
                </div>
                <div className="form__button">
                    <button type="button" onClick={calculate}>Submit</button>
                    <button type="reset" className="btn-Reset" onClick={handleReset}>Reset</button>
                </div>
                <div className="form__field">
                    {errors.time && (
                        <span className="invalid-feedback d-block">{errors.time}</span>
                    )}
                    <div className="tot_amount">
                        <span>Approximate Gratuity</span> AED {Number(gratuity).toLocaleString()}
                    </div>
                </div>
            </div>
        </div>
    );
}
